module.exports = __webpack_public_path__ + "img/loge.07d2ac46.png";